import { useEffect, useState } from "react";
import { ShieldCheck, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ExplainAccessPanel, useExplainAccess } from "@/components/permissions/ExplainAccess";

export function EffectivePermsDialog({ userId, userName, open, onClose }) {
  const { data, loading } = useExplainAccess(userId, open);
  const [catalog, setCatalog] = useState(null);
  useEffect(() => {
    if (!open || catalog) return;
    api.get("/permissions/matrix").then((r) => setCatalog(r.data)).catch(() => {});
  }, [open, catalog]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="effective-perms-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-primary" /> Explain access{userName ? ` — ${userName}` : ""}</DialogTitle>
          <DialogDescription>Audience defaults, adjusted by the role, adjusted by this person&apos;s own grants and revokes.</DialogDescription>
        </DialogHeader>
        {loading ? (
          <div className="flex justify-center py-8"><Loader2 className="h-5 w-5 animate-spin text-slate-300" /></div>
        ) : !data ? (
          <div className="py-8 text-center text-sm text-slate-400">Could not load permissions.</div>
        ) : (
          <ExplainAccessPanel data={data} catalog={catalog} compact />
        )}
      </DialogContent>
    </Dialog>
  );
}
